export default __webpack_public_path__ + "static/media/5.5ec01e17.png";